/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-access-state-in-setstate */
import React, { useEffect, useState, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { Table, Form, Button, Drawer, Col, Row, Badge, Tooltip } from 'antd';
import { GLOBAL_TABLE_SIZE, GLOBAL_TABLE_YSCROLL } from 'global_config/constant-global';
import DynamicInput from './dynamic_input';
import ChartDrawer from './chart_drawer';
import { fetchLineChartHistory } from 'services/lab_result/result';
import { useHotkeys } from 'react-hotkeys-hook';
import { EditResultContext } from 'context/editResultContext';
// import './result_table.css';
import { toUpper } from 'lodash';

import WebSocketService from '../../../../../services/websocket/WebSocketService';

function HotkeyWrapper({ children, hotkey, handler }) {
	//drop the beat
	useHotkeys(
		hotkey,
		() => {
			handler();
		},
		{ enableOnFormTags: ['INPUT', 'input'] },
	);

	return <div>{children}</div>;
}

HotkeyWrapper.propType = {
	children: PropTypes.node,
	hotkey: PropTypes.string,
	handler: PropTypes.func,
};

function EditableTable({
	resultStatus,
	results,
	formatedResults,
	onChangeResult,
	headerDetails,
	// selectedIresults,
	tableFormValues,
	setTableResults,
	recontructExamItems,
	specimenStatusID,
}) {
	const [drawerVisible, setDrawerVisible] = useState(false);
	const [examFieldValues, setExamFieldValues] = useState({});
	const [patientHistory, setPatientHistory] = useState([]);
	const { selectedIresults } = useContext(EditResultContext);
	
	const [messageHistoryFormula, setMessageHistoryFormula] = useState([]);

	// for modification of results
	const [customResults, setCustomResults] = useState([]);
	const [tableRowData, setTableRowData] = useState(null);
	const customFormatedResult = recontructExamItems(customResults);
	const [firstLoadIsTrue, setFirstLoadIsTrue] = useState(true);

	const columns = [
		// {
		// 	title: 'KEY',
		// 	width: 120,
		// 	render:(text, record)=>{
		// 		return `${record.sampleSpecimenID}-${record.examItemID}`;
		// 	}
		// },
		{
			title: 'EXAM',
			dataIndex: 'examItemName',
			width: 220,
			render: (text, record) => <div style={record.isChild && { marginLeft: 30 }}>{text}</div>,
		},
		{
			title: 'INS. RESULT',
			dataIndex: 'instrumentResult',
			width: 150,
			render: (text, record) =>{
				if(selectedIresults.length > 0){
					const insResultText = selectedIresults.find(ires => ires.fieldName === `${record.sampleSpecimenID}-${record.examItemID}`);

					if(![undefined, null,'undefined', 'null'].includes(insResultText)){
						return insResultText.iresults_value;
					}				
				}
				
				return text;
			},
		},
		{
			title: 'RESULT',
			dataIndex: 'releasedResult',
			width: 150,
			render: (text, record) => {
				if (record.releasedResult !== undefined /*&& (record.examRequestItemFormula === '' && record.examRequestItemFormulaDependent !== null)*/ ) {
					return createFormInput({
						...record,
						fieldName: `${record.sampleSpecimenID}-${record.examItemID}`,
					});
				}

				return '';
			},
		},
		{
			title: 'UNIT CODE',
			width: 100,
			render: (text, record) => {
				if (record.unitOfMesureBase && record.examItemUnitCode)
					return `${record.unitOfMesureBase} - ${record.examItemUnitCode}`;

				return '';
			},
		},
		{
			title: 'NORMAL VALUES',
			dataIndex: 'displayValue',
			width: 150,
		},
		{
			title: 'STATUS',
			dataIndex: 'flag',
			width: 120,
			render: (text, record) => {
				if (record.flag !== 'NORMAL' && record.flag !== undefined)
					return (
						<div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>{`${toUpper(
							record.flag,
						)}`}</div>
					);

				return '';
			},
		},
	];
	const [formRef] = Form.useForm();
	const showDrawerFromTable = () => {
		setDrawerVisible(true);
	};

	useEffect(() => {

		if (selectedIresults.length > 0) {
			const iResObj = {}; 

			selectedIresults.forEach(item => {
				iResObj[`${item.fieldName}`] = item.iresults_value;
			});

			const stgCustomRes = customResults.map(cr => {
				const targResult = selectedIresults.find( arr => (arr.sampleSpecimenID === cr.sampleSpecimenID && arr.examItemID === cr.examItemID));
				if(![undefined, null, 'undefined', null].includes(targResult)){
					cr.instrumentResult = targResult.iresults_value;
				}else{
					cr.instrumentResult = '';
				}
				
				return cr;	
			});

			setCustomResults(stgCustomRes);
			getFormValues();
			// @ts-ignore
			formRef.setFieldsValue(iResObj);
		}
	}, [selectedIresults]);

	useEffect(() => {
	const unsubscribe = WebSocketService.subscribe((message) => {

		// Normalize message → array
		const messages = Array.isArray(message) ? message : [message];

		if (messages.length === 0) return;

		const { FN, FRM, SRCID } = messages[0];

		// ======================
		// FORMULA
		// ======================
		if (FN === 'FORMULA') {

			setCustomResults(prevResults => {

				// Build lookup once (performance)
				const valueByCode = new Map(
					messages.map(m => [m.CODE, m.VALUE])
				);

				return prevResults.map(item => {

					if (valueByCode.has(item.examItemID)) {
						const value = valueByCode.get(item.examItemID);
						const fieldName = `${item.sampleSpecimenID}-${item.examItemID}`;

						formRef.setFieldValue(fieldName, value);

						return { ...item, releasedResult: value };
					}

					return item;
				});
			});

			return;
		}

		// ======================
		// GETFLAGS
		// ======================
		if (
			FN === 'GETFLAGS' &&
			FRM === 'RESULTEDIT' &&
			SRCID
		) {
			setCustomResults(prevResults =>
				prevResults.map(row =>
					row.examItemID === SRCID
						? { ...row, flag: messages[0].VALUE }
						: row
				)
			);
		}
	});

	return () => unsubscribe();
	}, []);

	const closeDrawerFromTable = () => {
		// this.setState({drawerVisible:false});
		setDrawerVisible(false);
	};

	//get results and save to useeffect to modified
	useEffect(() => {
		if (results) {
			setCustomResults(JSON.parse(JSON.stringify(results)));
		}
	}, [results]);

	useEffect(() =>{
		// console.log('customResults changed =>', customResults);
		let labResults = {
			results: customResults,
			// hasError: false,
		};
		setTableResults(labResults);
	}, [customResults]);

	//get results in first load and pass to setTableResult
	if (results !== 0) {
		if (firstLoadIsTrue === true && customResults.length !== 0) {
			let labResults = {
				results: customResults,
				// hasError: err !== null,
				hasError: false,
			};

			// console.log('labResults =>', labResults);

			setTableResults(labResults); // passess table form values to parent component edit_result
			setFirstLoadIsTrue(false);
		}
	}

	const handleChangeResult = () => {
		onChangeResult();
		getFormValues();
		// console.log('form customResults before change =>', customResults);
		setTableResults(customResults);
	};

	const createFormInput = record => {
		if (record) {
			const initialValue = record.releasedResultMultiple
				? record.releasedResultMultiple
				: record.releasedResult;
			return (
				<Form.Item name={record.fieldName} initialValue={initialValue}>
					<DynamicInput
						hideElements={false}
						type={record.examItemTypeCode}
						isLock={
							record.examRequestItemLock === 1 ||
							resultStatus === 'Approved' ||
							specimenStatusID === 3 ||
							specimenStatusID === 5
						}
						itemOptions={record.examItemOptions}
						maxLength={record.maxLength}
						onChange={handleChangeResult}
					/>
				</Form.Item>
			);
		}
	};

	// This is use to get the values of this form up to its parent
	// component e.g(update/add form) to cancel the submitting of
	// data once an error validation appears
	const getFormValues = () => {
		const fieldsValue = formRef.getFieldsValue();
		// const clonedResults = JSON.parse(JSON.stringify(results));

		const combinedResults = customResults.map(item => {
			const key = Object.keys(fieldsValue).find(
				x => x === `${item.sampleSpecimenID}-${item.examItemID}`,
			);
			const releasedResult = item.examItemTypeCode !== 'cb' ? fieldsValue[key] : null;
			const releasedResultMultiple = item.examItemTypeCode === 'cb' ? fieldsValue[key] : null;

			return {
				...item,
				rangeHighFlagDisplay: toUpper(item.rangeHighFlagDisplay),
				rangeLowFlagDisplay: toUpper(item.rangeLowFlagDisplay),
				releasedResult,
				releasedResultMultiple,
				unitOfMesureBase: item.unitOfMesureBase || '0 0',
			};
		});

		if (tableRowData) {
			//FOR FLAGS
			const targetObject = combinedResults.find(
				item => item.examItemID === tableRowData.examItemID,
			);

			const modifiedPropertyCustomResult = {
				FN: 'GETFLAGS',
				FRM: 'RESULTEDIT',
				SRCID: targetObject.examItemID,
				VALUE: targetObject.releasedResult,
				LL: targetObject.rangeLow,
				UL: targetObject.rangeHigh,
				LV: toUpper(targetObject.rangeLowFlagDisplay),
				HV: toUpper(targetObject.rangeHighFlagDisplay),
				NV: '',
			};
			//Send the modified the Property of CustomResult as a string to the WebSocket
			WebSocketService.sendMessage(modifiedPropertyCustomResult);

			//FOR FORMULA
			if (targetObject.examRequestItemFormulaDependent !== null && targetObject.examRequestItemFormula === '' ) {

				const combinedResultFormula = combinedResults.filter(item => {
					return (item.examRequestItemFormulaDependent !== null  || item.examRequestItemFormula !== '');
				  });
				
				  const mapCombinedResult = combinedResultFormula.map((item, index) => ({
					COL: "RESULT",
					ROW: index,
					CODE: item.examItemID,
					VALUE: item.releasedResult,
					FORMULA: item.examRequestItemFormula
				  }));

				const modifiedPropertyCustomResultFormula = {
					FN: 'FORMULA',
					FRM: 'RESULTEDIT',
					SRCID: targetObject.examItemID,
					TVAL: mapCombinedResult
				};
				WebSocketService.sendMessage(modifiedPropertyCustomResultFormula);
			}
		}

		console.log('form combinedResults =>', combinedResults);
		setCustomResults(combinedResults);

		// labResults = {
		// 	results: customResults,
		// hasError: err !== null,
		// 	hasError: false,
		// };

		// return labResults;
		return combinedResults;
	};

	const handleOnSaveChartDrawer = updatedCustomResults => {
		if (updatedCustomResults) {

			const filteredResult = updatedCustomResults.filter(item => item.releasedResult);
			filteredResult.forEach(item => {
				const modifiedPropertyCustomResult = {
					FN: 'GETFLAGS',
					FRM: 'RESULTEDIT',
					SRCID: item.examItemID,
					VALUE: item.releasedResult,
					LL: item.rangeLow,
					UL: item.rangeHigh,
					LV: toUpper(item.rangeLowFlagDisplay),
					HV: toUpper(item.rangeHighFlagDisplay),
					NV: '',
				};
				// sendMessage(JSON.stringify(modifiedPropertyCustomResult));
			});
		}
	};

	//used to toggle visibility of Chart Drawer
	const toggleDrawer = () => {
		// const { drawerVisible } = this.state;
		if (!drawerVisible) {
			// this.setState({drawerVisible : true});
			setDrawerVisible(true);
		} else {
			setDrawerVisible(false);
			// this.setState({drawerVisible : false});
		}
	};

	const showChartDrawer = async () => {
		// const { headerDetails } = this.props;
		const { patientInfo, specimenID, selectedSectionID } = headerDetails;
		const { patientID } = patientInfo;
		// const examFieldValues = formRef.current.getFieldsValue();
		const examFieldValues = formRef.getFieldsValue();
		const data = await fetchLineChartHistory(patientID, selectedSectionID, specimenID);
		// this.setState({examFieldValues: examFieldValues, patientHistory: data}); //passed data in Chart Drawer
		setExamFieldValues(examFieldValues);
		setPatientHistory(data);
		toggleDrawer();
	};

	const catchChanges = fieldsFromChartDrawer => {
		if (fieldsFromChartDrawer !== undefined) {
			formRef.setFieldsValue(fieldsFromChartDrawer);
			onChangeResult();
		}
	};

	const { patientInfo, sampleSpecimenID } = headerDetails;
	const { lastName, givenName } = patientInfo;
	const drawerTitle = `${lastName}, ${givenName} | Sample ID: ${sampleSpecimenID}`;

	return (
		<div className="labresult-exam-item-table">
			{/* {renderConnectionStatus()} */}
			<HotkeyWrapper handler={showChartDrawer} hotkey="ctrl+enter">
				<Form form={formRef}>
					<Table
						dataSource={customResults ? customFormatedResult : formatedResults}
						columns={columns}
						rowKey={item => item.examItemID}
						scroll={{ x: 800, y: GLOBAL_TABLE_YSCROLL }}
						size={GLOBAL_TABLE_SIZE}
						pagination={false}
						onRow={record => {
							return {
								onClick: () => {
									setTableRowData(record);
								},
								onFocus: () => {
									setTableRowData(record);
								},
							};
						}}
					/>
					<HotkeyWrapper handler={catchChanges} hotkey="shift+enter">
						<ChartDrawer
							formatedResults={formatedResults}
							visible={drawerVisible}
							toggleDrawer={toggleDrawer}
							drawerTitle={drawerTitle}
							resultStatus={resultStatus}
							currentFieldValues={examFieldValues}
							catchChanges={catchChanges}
							patientHistory={patientHistory}
							// onChangeResult={onChangeResult}
						/>
					</HotkeyWrapper>
				</Form>
			</HotkeyWrapper>
		</div>
	);
}

EditableTable.propTypes = {
	resultStatus: PropTypes.string.isRequired,
	results: PropTypes.array.isRequired,
	formatedResults: PropTypes.array.isRequired,
	onChangeResult: PropTypes.func.isRequired,
	headerDetails: PropTypes.object.isRequired,
	selectedIresults: PropTypes.array,
};

// export default Form.create()(EditableTable);
export default EditableTable;
